import {useState} from 'react'
import {OfferNode} from '../types'
import {Children, ChildWrap, Connector, Node} from './OfferTreeNode.styled'
import {OfferTreeCard} from './OfferTreeCard'

type OfferTreeNodeProps = {
  node: OfferNode
}

/**
 * Recursively renders a single offer card and, when expanded, its nested sub-offers.
 *
 * Expansion state is held per node so each branch collapses independently. There is no
 * depth limit — the component recurses for as many levels as the tree contains.
 *
 * @param node - The offer tree node to render (offer data, depth and child nodes).
 */
export const OfferTreeNode = ({node}: OfferTreeNodeProps) => {
  const [expanded, setExpanded] = useState(true)
  const hasChildren = node.children.length > 0

  return (
    <Node>
      <OfferTreeCard
        node={node}
        hasChildren={hasChildren}
        expanded={expanded}
        onToggleExpand={() => setExpanded((value) => !value)}
      />
      {hasChildren && expanded && (
        <Children>
          {node.children.map((child, index) => (
            <ChildWrap key={child.offer.id ?? index}>
              <Connector aria-hidden="true" />
              <OfferTreeNode node={child} />
            </ChildWrap>
          ))}
        </Children>
      )}
    </Node>
  )
}
